module.exports = __webpack_public_path__ + "assets/f46fdb3f2ee193fc89d91a3a2ca1bc7f.png";